<div class="grid-page-template">
  <div class="breadcrumbs">
    <ng-content select="[breadcrumbs]"></ng-content>
  </div>
  <div class="title">
    <ng-content select="[title]"></ng-content>
  </div>
  <div class="body">
    <div class="grid-page-template__card grid-page-template__card--search">
      <ng-content select="[search]"></ng-content>
    </div>
    <div class="grid-page-template__card">
      <ng-content select="[card]"></ng-content>
    </div>
  </div>
</div>
